import { useGetApiV1ExamLangsId } from '@/shared/api/generated';

/**
 * Hook para obter o detalhe de um idioma de prova pelo seu ID.
 *
 * Utilizado para pre-popular o formulário de edição com os dados atuais,
 * incluindo o campo de instruções que não está disponível na listagem.
 *
 * @param id - ID do idioma de prova. Quando `undefined`, a query não é executada.
 * @returns Dados do idioma e estado de carregamento
 */
export function useExamLangDetail(id: number | undefined) {
  const { data, isLoading } = useGetApiV1ExamLangsId(id ?? 0, {
    query: { enabled: id !== undefined && id > 0 },
  });

  return { langDetail: data, isLoading } as const;
}
